// Module
var code = "<h1 id=\"engagements\">Engagements</h1> <p>This is where the educator engagement of lesson planning is displayed.</p> <p>The ratio is based on how many lesson plans one educator made out of all the lesson plans made by the whole campus.</p> ";
// Exports
module.exports = code;